<template>
  <div class="valid-table">
    <h3 class="table-title">
      {{
        `可导入数据${data?.passList?.length || 0}条，${
          data?.errorList?.length && data.errorList.length > 0
            ? "部分数据校验失败，请检查清单内容，尝试重新导入"
            : ""
        }（校验失败：${data?.errorList?.length || 0}条）`
      }}
    </h3>
    <vxe-table
      border
      :loading="checkLoading"
      :data="data?.errorList"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      show-overflow="tooltip"
    >
      <vxe-column fixed="left" type="seq" width="80" align="center" title="序号"></vxe-column>
      <template v-for="item in column">
        <vxe-column
          :field="item.dataIndex || item.key"
          :title="item.title"
          :min-width="item.width"
          :fixed="item.fixed"
          align="center"
          show-overflow="tooltip"
        ></vxe-column>
      </template>
      <template #empty>
        <a-empty :image="simpleImage">
          <template #description>暂无数据</template>
        </a-empty>
      </template>
    </vxe-table>
    <a-row type="flex" align="center" style="margin: 20px 0 0">
      <a-col>
        <a-button @click="updateStep(1)">上一步</a-button>
        <a-button
          type="primary"
          @click="updateStep(3)"
          :disabled="!data?.passList?.length"
          :loading="checkLoading"
          >导入</a-button
        >
        <a-button
          type="primary"
          @click="updateStep(13)"
          v-if="indexSetMap.size && keyFields.length > 0"
          :loading="checkLoading"
          >合并导入</a-button
        >
        <a-button
          @click="exportExcel()"
          v-if="data?.errorList?.length && checkType && checkType != ''"
          :loading="checkLoading || exportLoading"
          >下载校验数据</a-button
        >
        <!--  -->
      </a-col>
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { FormMultipleImportService } from "./form-multiple-import.service";

export default defineComponent({
  name: "DataValid",
});
</script>

<script lang="ts" setup>
import { computed, PropType } from "vue";
import { VxeTablePropTypes } from "vxe-table";
import { Empty, message } from "ant-design-vue";
import _ from "lodash";
const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  originalList: {
    type: Array,
    default: () => [],
  },
  fail: {
    type: Number,
    default: 0,
  },
  checkLoading: {
    type: Boolean,
    default: true,
  },
  total: {
    type: Number,
    default: 0,
  },
  tableHeight: {
    type: Number,
    default: 200,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  uploadApiFn: {
    type: Function,
  },
  keyFields: {
    type: Array,
    default: () => [],
  },
  checkType: {
    type: String,
  },
  checkKey: {
    type: String,
  },
});

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
const { run: runExport, loading: exportLoading } = FormMultipleImportService.useExportExcelData();
const emit = defineEmits(["setSteps", "emitData"]);

const column = computed(() => {
  return [
    ...props.columns,
    { title: "校验结论", width: 200, dataIndex: "failDesc", key: "failDesc", fixed: "right" },
  ];
});
const indexSetMap = computed(() => {
  let m = new Map();
  for (const key in props.data?.innerMapData?.indexSetMap) {
    m.set(key, props.data.innerMapData.indexSetMap[key]);
  }
  // console.log("🚀 ~ file: data-valid.vue:127 ~ indexSetMap ~ m:", m);
  return m;
});

const cellClassName: VxeTablePropTypes.CellClassName = ({ row, column }) => {
  if (column.field === "failDesc") {
    return "color-red";
  }
  return "";
};

const exportExcel = async () => {
  let res = await runExport(props.checkKey, props.checkType);
  if (res.respCode !== "0000") {
    message.error(res.respDesc);
    return;
  }
  message.success(res.respDesc);
  if (res.data && res.data.url) {
    window.open(res.data.url);
  }
};
// const { run, loading } = props.uploadApiFn();

async function updateStep(step: number) {
  if (step === 13) {
    // const data = await run(props.data?.passList);
    // if (data?.respCode === "0000") {

    // }
    let emData = _.cloneDeep(props.data.passList);
    indexSetMap.value.forEach((value, key) => {
      if (props.keyFields.length > 0) {
        for (let i = 0; i < props.keyFields.length; i++) {
          let field = props.keyFields[i] as string;
          let allCount = isNaN(Number(emData[key][field])) ? 0 : Number(emData[key][field]);
          for (let j = 0; j < value.length; j++) {
            allCount += isNaN(Number(props.data.errorList[value[j]][field]))
              ? 0
              : Number(props.data.errorList[value[j]][field]);
          }
          emData[key][field] = allCount;
        }
      }
    });
    emit("emitData", emData);
  } else {
    emit("setSteps", step);
  }
}
</script>

<style lang="less" scoped>
.valid-table {
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  height: calc(100% - 72px);
  overflow-y: auto;
  .table-title {
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
  }
  .vxe-table {
    min-height: 200px;
    margin-bottom: 10px;
    :deep(.color-red) {
      color: red;
    }
  }
}
</style>
